// extracted by mini-css-extract-plugin
module.exports = {"mainTable":"correctionReadyProductsTable_mainTable__1xJxo","danger":"correctionReadyProductsTable_danger__PlLyW"};